import { render, staticRenderFns } from "./order_share.vue?vue&type=template&id=76bf5e9c"
import script from "./order_share.vue?vue&type=script&lang=js"
export * from "./order_share.vue?vue&type=script&lang=js"
import style0 from "./order_share.vue?vue&type=style&index=0&id=76bf5e9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports